import api from '../api';
import { serviceReutils } from '../../utils/reutils';

export const ServiceLotacao = {
  ...serviceReutils({ name: 'rotas/v1/lotacao', api }),
};
